import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2GlobeIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.196 20.999",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.196),
    children: [/*#__PURE__*/jsx("path", {
      d: "m.55 10.5a10 10 0 1 0 10-10 10 10 0 0 0 -10 10z"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.177 13.833a1.333 1.333 0 0 0 1.293-1.657l-.667-2.667a1.333 1.333 0 0 0 -1.293-1.01h-4.759a10 10 0 0 0 3.57 9.815l.9-4.482z"
    }), /*#__PURE__*/jsx("path", {
      d: "m18.536 4.5h-3.613a1.333 1.333 0 0 0 -1.293 1.01l-.666 2.665a1.333 1.333 0 0 0 1.293 1.657h1.4l.7 4.222a1.333 1.333 0 0 0 1.316 1.114h1.711a9.955 9.955 0 0 0 -.854-10.666z"
    })]
  });
};

export { PM2GlobeIcon };
//# sourceMappingURL=globe.js.map
